import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import { styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";
import { CardContent } from "simplydo/react/ui/card";
import { Container } from "simplydo/react/ui/container";
import {
  Placeholder,
  PlaceholderLine,
  PlaceholderParagraph,
} from "simplydo/react/ui/placeholder";

import api from "api";

import ActivityFeedBlock from "./blocks/ActivityFeedBlock/ActivityFeedBlock";
import AssessmentsBlock from "./blocks/AssessmentsBlock";
import BusinessProfilesBlock from "./blocks/BusinessProfilesBlock";
import ExploreChallengesBlock from "./blocks/ExploreChallengesBlock";
import GroupsBlock from "./blocks/GroupsBlock";
import HeaderBlock from "./blocks/HeaderBlock";
import HomeBlock from "./blocks/HomeBlock";
import InvitationsBlock from "./blocks/InvitationsBlock/InvitationsBlock";
import PagesBlock from "./blocks/PagesBlock";
import PollsBlock from "./blocks/PollsBlock";
import ProjectAssignedIdeasBlock from "./blocks/ProjectAssignedIdeasBlock";
import SecurityRecommendationsBlock from "./blocks/SecurityRecommendationsBlock";
import TasklistBlock from "./blocks/TasklistBlock";
import UserIdeasBlock from "./blocks/UserIdeasBlock";

const Grid = styled.div`
  display: grid;
  grid-template-columns: ${({ theme }) =>
    theme.sizes.isComputer ? "repeat(2, minmax(0, 1fr))" : "minmax(0, 1fr)"};
  grid-auto-flow: dense;
  grid-auto-rows: min-content;
  gap: 1rem;
`;

const Home = () => {
  const theme = useTheme();

  const dashboardQuery = useQuery(
    initUseQuery(api.users.dashboard, [], { staleTime: 30 * 1000 }),
  );

  if (dashboardQuery.isLoading)
    return (
      <Container style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: theme.sizes.isComputer
              ? "minmax(0, 3fr) minmax(0, 1fr)"
              : "minmax(0, 1fr)",
            gridAutoRows: "min-content",
            gap: 24,
          }}
        >
          <Grid>
            <div
              style={{
                gridColumn: theme.sizes.isComputer ? "span 2" : "span 1",
              }}
            >
              <Placeholder>
                <PlaceholderParagraph>
                  <PlaceholderLine style={{ height: 40 }} length="medium" />
                  <PlaceholderLine style={{ height: 80 }} />
                </PlaceholderParagraph>
              </Placeholder>
            </div>
            {Array.from({ length: 10 }).map((_, index) => (
              <HomeBlock key={index}>
                <CardContent>
                  <Placeholder>
                    <PlaceholderLine style={{ height: 300 }} />
                  </Placeholder>
                </CardContent>
              </HomeBlock>
            ))}
          </Grid>
          <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
            <HomeBlock>
              <CardContent>
                <Placeholder>
                  <PlaceholderLine style={{ height: "60vh" }} />
                </Placeholder>
              </CardContent>
            </HomeBlock>
          </div>
        </div>
      </Container>
    );

  return (
    <Container style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: theme.sizes.isComputer
            ? "minmax(0, 3fr) minmax(0, 1fr)"
            : "minmax(0, 1fr)",
          gap: "1rem",
        }}
      >
        <Grid>
          <HeaderBlock />
          <TasklistBlock />
          <SecurityRecommendationsBlock />
          <InvitationsBlock />
          <AssessmentsBlock variant="pending" />
          <UserIdeasBlock variant="draft" />
          <ProjectAssignedIdeasBlock />
          <GroupsBlock />
          <AssessmentsBlock variant="completed" />
          <UserIdeasBlock variant="submitted" />
          <ExploreChallengesBlock />
          <BusinessProfilesBlock />
          <PagesBlock />
        </Grid>
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <PollsBlock />
          <HomeBlock
            style={
              theme.sizes.isComputer
                ? {
                    maxHeight: "calc(100vh - 100px)",
                    position: "sticky",
                    top: 75,
                    height: "auto",
                    minHeight: "90vh",
                  }
                : { minHeight: "90vh" }
            }
          >
            <CardContent style={{ height: "100%" }}>
              <ActivityFeedBlock />
            </CardContent>
          </HomeBlock>
        </div>
      </div>
    </Container>
  );
};

export default Home;
